import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Virtuoso } from 'react-virtuoso';
import { List, ListItem, Portal } from '@chakra-ui/react';
import { useSelectContext } from '../SelectContext';
import { itemToValue } from '../utils/itemUtils';
import { DropdownItem } from './DropdownItem';
import { useSelectPopover } from './SelectPopover';
export const SelectMenu = () => {
    const { getMenuProps, isOpen, items, nothingFoundLabel, styles, virtualListRef, virtualListHeight, } = useSelectContext();
    const { floatingRef, floatingStyles } = useSelectPopover();
    return (_jsx(Portal, { children: _jsxs(List, { ...getMenuProps({ ref: floatingRef }, 
            // Suppressing ref error since this will be in a portal and will be conditionally rendered.
            // See https://github.com/downshift-js/downshift/issues/1272#issuecomment-1063244446
            { suppressRefError: true }), style: floatingStyles, sx: styles.list, zIndex: "dropdown", children: [isOpen && items.length > 0 && (_jsx(Virtuoso, { ref: virtualListRef, data: items, overscan: virtualListHeight / 2, style: { height: virtualListHeight }, itemContent: (index, item) => {
                        return (_jsx(DropdownItem, { item: item, index: index }, `${itemToValue(item)}${index}`));
                    } })), isOpen && items.length === 0 ? (_jsx(ListItem, { role: "option", sx: styles.emptyItem, children: nothingFoundLabel })) : null] }) }));
};
